export const aciIsoAmNocircle = {
    iconName: 'iso-am-nocircle',
    iconData: [
        128,
        128,
        `M110.751 41.934C105.746 26.388 90.327 8 63.774 8c-11.511 0-22.855 4.247-31.916 11.939-19.997 16.983-22.792 46.032-6.285 64.75 5.72 6.447 11.893 11.55 16.551 13.713l27.781-23.026H44.45l-.164-.197c-10.307-11.895-9.533-29.354 1.75-38.933 5.152-4.383 11.583-6.792 18.092-6.792 7.692 0 15.078 3.346 20.229 9.187 4.739 5.347 7.017 12.176 6.448 19.256-.573 7.077-2.782 13.119-8.882 18.251-.167.152-33.425 27.813-33.425 27.813L64.254 120l31.895-27.346c18.771-17.294 19.199-36.43 14.602-50.72z`,
    ],
};
